var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.329,
    height: 25.328,
    viewBox: "0 0 25.329 25.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1044.135,91.291l-6.424-6.424a1.477,1.477,0,0,0-1.128-.428L1034.3,82.15a8.434,8.434,0,1,0-1.4,1.4l2.288,2.288a1.476,1.476,0,0,0,.428,1.129l6.424,6.424a1.485,1.485,0,1,0,2.1-2.1Zm-16.566-7.918A6.435,6.435,0,1,1,1034,76.939,6.434,6.434,0,0,1,1027.569,83.373Z",
    transform: "translate(-1019.241 -68.498)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.7c456152ef4d2c17fed32a8d08daf282.svg";
export { ForwardRef as ReactComponent };